import { z } from "zod";

import { monthlyAuditDate } from "@/schemas";

import { environmentalChecklistItem } from "../../../../schemas";

export const resEnvChecklistFreezerSchema = z.object({
  auditDate: monthlyAuditDate,
  locationId: z.string().min(1, "Required"),
  reviewerId: z.string().min(1, "Required"),
  freezerTempLog: environmentalChecklistItem,
  freezerDefrosted: environmentalChecklistItem,
  freezerUnder: environmentalChecklistItem,
  freezerTop: environmentalChecklistItem,
  freezerRepair: environmentalChecklistItem,
  freezerComment: z.string().optional(),
});
